import React from "react";
import { Navigate } from "react-router-dom";

/**
 * Guards routes that should only be reachable after a successful login.
 * Previously every page was public - anyone could type the URL directly
 * and skip the login form entirely. This checks for the auth token that
 * Login.js / LiveAttendanceLogin.js store in localStorage and bounces
 * unauthenticated users back to the login page.
 */
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
